<template>
  <div v-if="visible" class="tw-fixed tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center  tw-bg-opacity-30 tw-backdrop-blur-lg tw-z-50">
    <div class="tw-rounded-full tw-bg-gradient-to-r tw-from-gray-200 tw-to-gray-300 tw-shadow-lg tw-mb-4">
      <div class="loader-container">
        <div class="loader"></div>
      </div>
    </div>
    <div class="loader-text tw-font-bold tw-text-lg tw-text-blue-800 tw-text-center">
      <span>APA INSURANCE</span>
    </div>
    <div class="loader-subtext tw-text-xs tw-font-bold tw-text-blue-800 tw-text-center tw-shadow-sm">
      <span class="tw-text-red-600">GENERAL</span>
      <span class="separator tw-inline-block tw-w-1 tw-h-1 tw-bg-blue-800 tw-rounded-full tw-mx-2"></span>
      <span>LIFE</span>
      <span class="separator tw-inline-block tw-w-1 tw-h-1 tw-bg-blue-800 tw-rounded-full tw-mx-2"></span>
      <span class="tw-text-red-600">HEALTH</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    const SHOW_LOADER = 'show-loader';
    const HIDE_LOADER = 'hide-loader';

    this.$bus.$on(SHOW_LOADER, () => {
      this.visible = true;
    });
    this.$bus.$on(HIDE_LOADER, () => {
      this.visible = false;
    });
  },
  beforeDestroy() {
    this.$bus.$off('show-loader');
    this.$bus.$off('hide-loader');
  },
};
</script>

<style scoped>
.loader-container {
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

.loader {
  width: 100%;
  height: 100%;
  background-image: url('../../../public/images/smiley.png');
  background-size: 80%;
  background-position: center;
  background-repeat: no-repeat;
}

.tw-backdrop-blur-lg {
  backdrop-filter: blur(10px);
}

.loader-text span {
  color: #0c4da2;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
